import { Tooltip } from '@chakra-ui/react';

export default function ChakraTooltip({
    children,
    portalProps,
    zIndex = 999999,
    ...props
}) {
    return (
        <Tooltip
            {...props}
            overflow="initial"
            zIndex={zIndex}
            portalProps={{
                containerRef: undefined,
                ...portalProps,
            }}>
            {children}
        </Tooltip>
    );
}
